import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js"; // UTC plugin
import timezone from "dayjs/plugin/timezone.js"; // Timezone plugin
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const groupMatchesByLeagueId = (data) => {
  const filteredLeagues = data.reduce((leagues, currentMatch) => {
    if (!currentMatch) {
      return leagues;
    }

    const { league, ...restMatch } = currentMatch;

    const leagueId = league?.id;
    if (!leagueId) {
      return leagues;
    }

    if (!leagues[leagueId]) {
      leagues[leagueId] = {
        ...league,
        matches: [restMatch],
      };
    } else {
      leagues[leagueId].matches.push(restMatch);
    }

    return leagues;
  }, {});

  return filteredLeagues ? Object.values(filteredLeagues) : [];
};

export const formatDateForApi = (date) => {
  return getTodayDate({ date });
};

export const getTodayDate = ({ date }) => {
  if(!date) {
    return dayjs().tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD");
  }

  const dateVN = dayjs(date).tz("Asia/Ho_Chi_Minh");
  return dateVN.format("YYYY-MM-DD");
};

export const formatDateTime = (matchTimeInUnix) => {
  const dateTime = dayjs.unix(matchTimeInUnix).tz("Asia/Ho_Chi_Minh");
  const date = dateTime.format("DD/MM");
  const time = dateTime.format("HH:mm");

  return { date, time };
};

export const formatVNTime = (date) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Ho_Chi_Minh",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const hour = parts.find((p) => p.type === "hour").value;
  const minute = parts.find((p) => p.type === "minute").value;

  return `${hour}:${minute}`;
};

export const formatHandicapLabel = (value, isHome) => {
  const num = parseFloat(value);
  if (isHome) {
    return num > 0 ? `-${value}` : value || "-1";
  }
  return num < 0 ? Math.abs(num) : `+${value || 1}`;
};

export const formatHandicapLabelForDisplay = (value, isHome) => {
  if (value == null || value === "" || value === "-") return "";
  const num = parseFloat(value);
  if (Number.isNaN(num)) return "";
  return formatHandicapLabel(value, isHome);
};

const THU_VI = ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"];

export const formatUnixToVNDate = (unixTimestamp) => {
  const d = dayjs.unix(unixTimestamp).tz("Asia/Ho_Chi_Minh");
  return {
    date: d.format("DD/MM"),
    thu: THU_VI[d.day()],
    gio: d.format("HH:mm"),
  };
};

export const formatStakeDateTime = (unixTimestamp) => {
  const date = new Date(Number(unixTimestamp || 0) * 1000);
  const dayMap = ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"];

  const weekdayDate = `${dayMap[date.getDay()]}, ${date.getDate()} Thg ${date.getMonth() + 1}`;

  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const isPm = hours >= 12;
  const displayHour = hours % 12 || 12;
  const time = `${displayHour}:${minutes} ${isPm ? "CH" : "SA"}`;

  return { weekdayDate, time };
};

export const makeTeamCode = (name = "") => {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
};

export const reverseHandicapLabel = (label = "") => {
  const clean = String(label || "").trim();
  if (!clean || clean === "0") return "0";
  if (clean.startsWith("-")) return clean.slice(1);
  return `-${clean}`;
};
